import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=06ebbdbb&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=06ebbdbb&prod&scoped=true&lang=css"
import style1 from "./suppliers.vue?vue&type=style&index=1&id=06ebbdbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebbdbb",
  null
  
)

export default component.exports